export default __webpack_public_path__ + "static/media/transactionlink.474c8b26.png";